export const SETTING_NAME_TABLE_COLUMN_SETTINGS: string = 'table-column-settings';
export const SETTING_NAME_WIDGET_SETTINGS: string = 'widget-settings';
export const SETTING_NAME_ACCOUNT_WIDGET_SETTINGS: string = 'account-widget-settings';
export const SETTING_NAME_ACCOUNT_STATISTIC_SETTINGS: string = 'account-statistic-settings';
export const SETTING_NAME_SHOW_NOTIFICATIONS: string = 'show-notifications';
export const SETTING_NAME_SHOW_ACCOUNT_LOGO: string = 'show-account-logo';
export const SETTING_NAME_HOMEPAGE: string = 'homepage';
export const SETTING_NAME_DEFAULT_PORTFOLIO_FILTER_IDS: string = 'default-portfolio-filter-ids';
export const SETTING_NAME_SEARCH_RESULT_GROUPS: string = 'search-result-groups';
export const SETTING_NAME_ACTIVITY_COMMENT_USER_MENTIONS: string = 'activity-comment-user-mentions';
export const SETTING_NAME_DEAL_TASK_COMMENT_USER_MENTIONS: string = 'deal-task-comment-user-mentions';
export const SETTING_NAME_CONTACT_COMMENT_USER_MENTIONS: string = 'contact-comment-user-mentions';
